import React, {useContext, useEffect, useState, useCallback, useRef} from 'react';
import VendorContentEmpty from './VendorContentEmpty';
import ShowMoreVendors from './ShowMoreVendors';
import {SearchContext} from '../../context/SearchContext';
import {RiveDemo} from '../../utils/animateExample';
import '../IndexConent/indexContent.css';
import {TextAnimator} from "../../utils/text-animator";
import AnswerResult from '../AnswerResult';

const SearchedVendors = ({onShowPopup}) => {
    // All your state and refs for animations remain untouched
    const [animator, setAnimator] = useState(null);
    const [hoverDescription, setHoverDescription] = useState(false);
    const descriptionRef = useRef(null);

    // Your context usage is perfect and remains the same
    const {
        vendorResults = [],
        searchVendorSended,
        loading,
        loadingMore,
        error,
        changeCompaniesForTitle
    } = useContext(SearchContext);

    // All your useEffect and useCallback hooks for animation remain exactly the same.
    // They are not related to data fetching logic and should be preserved.
    useEffect(() => {
        changeCompaniesForTitle('Vendors');
    }, [changeCompaniesForTitle]);

    useEffect(() => {
        if (descriptionRef.current) {
            const animatorInstance = new TextAnimator(descriptionRef.current);
            setAnimator(animatorInstance);
        }
    }, [vendorResults]);

    const animateText = useCallback(() => { /* ...your animation logic... */
    }, [animator]);
    const handleIntersection = useCallback((entries) => { /* ...your animation logic... */
    }, [animateText]);
    useEffect(() => { /* ...your IntersectionObserver logic... */
    }, [handleIntersection]);
    const handlerHover = useCallback(() => { /* ...your animation logic... */
    }, [hoverDescription, animateText]);

    // All of your conditional rendering for loading and error states is great and remains.
    if (error && error.status === 404) {
        return <VendorContentEmpty/>;
    }


    if (loading && !loadingMore && vendorResults.length === 0) {
        return (
            <main className='emptyContent'>
                <div className='content'>
                    <div className='icons'>
                        <RiveDemo/>
                    </div>
                    <span onMouseOver={handlerHover} onMouseLeave={() => setHoverDescription(false)}
                          className='title empty-animate' ref={descriptionRef}>
                        {'Loading...'}
                    </span>
                </div>
            </main>
        );
    }

    return (
        <div className="searched-vendors">
            {searchVendorSended ? (
                vendorResults.length === 0 ? (
                    <AnswerResult/>
                ) : (
                    <>
                        <div className="accordeon__el">
                            <div className={"accordeon__header"}>
                                <div className="header-content">
                                    <div className="container">
                                        <div className="justify"
                                             style={{justifyContent: 'flex-start', alignItems: 'center'}}>
                                            <div className='vendors'>
                                                <h4>
                                                    AI
                                                </h4>
                                            </div>
                                            &nbsp;&nbsp;&nbsp;
                                            <div className='icons'>
                                                <RiveDemo/>
                                            </div>
                                            &nbsp;&nbsp;
                                            <div className='vendors'>
                                                <h4
                                                    onMouseOver={handlerHover}
                                                    onMouseLeave={() => setHoverDescription(false)}
                                                    ref={descriptionRef}
                                                >
                                                    Searched Vendors:
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <ShowMoreVendors onShowPopup={onShowPopup}/>
                    </>
                )
            ) : (
                <VendorContentEmpty/>
            )}
        </div>
    );
};

export default SearchedVendors;